import { useMemo } from 'react';

import { Country } from '@electricjs/arc';

import { useStorefront } from '../StorefrontProvider';
import {
  getWarehouseEstimatedDeliveryDate,
  getWarehouseEstimatedShipDate,
} from './helpers';

/** Hook to get the current estimated dates (ship/delivery) of a warehouse asset order in storefront */
export const useCurrentWarehouseEstimatedDates = () => {
  const { storefrontCheckoutForm } = useStorefront();

  const selectedWarehouseShippingMethod = storefrontCheckoutForm?.watch(
    'warehouseShippingMethod'
  );

  const selectedShoppingCountry =
    storefrontCheckoutForm?.watch('shoppingCountry');

  const shoppingCountryCode =
    selectedShoppingCountry && selectedShoppingCountry?.value !== 'other'
      ? selectedShoppingCountry.value
      : ('US' as Country);

  const estimatedDates = useMemo(() => {
    if (!selectedWarehouseShippingMethod) {
      return;
    }

    const today = new Date();
    const shipDate = getWarehouseEstimatedShipDate(today);
    const deliveryDate = getWarehouseEstimatedDeliveryDate(
      shipDate,
      shoppingCountryCode,
      selectedWarehouseShippingMethod.value
    );

    return { shipDate, deliveryDate };
  }, [selectedWarehouseShippingMethod, shoppingCountryCode]);

  return estimatedDates;
};
